import { PageCanvas, FormContent } from "@/components/page-canvas";
import { Form, Head, Link, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import JobWorkspace from "@/components/job-workspace";
import { Button } from "@/components/ui/button";
import { locationRecordingOperationalNotificationsPath } from "@/routes";
import { Errors } from "../requests/controls";

export default function Preview({
  recording,
  preview,
}: {
  recording: { id: string };
  preview: {
    token: string;
    recipient: string | null;
    subject: string;
    body: string;
    action_url: string | null;
    eligible: boolean;
  };
}) {
  const { auth, job_context } = usePage().props;
  const { t } = useTranslation();
  if (!auth.location) return null;
  const path = locationRecordingOperationalNotificationsPath(
    auth.location.id,
    recording.id,
  );
  return (
    <JobWorkspace
      primaryAction={false}
      breadcrumbs={[{ title: t("notifications.history"), href: path }]}
    >
      <Head title={t("notifications.preview")} />
      <PageCanvas padded={!job_context}>
        <NotificationHeading>{t("notifications.preview")}</NotificationHeading>
        <Errors />
        <section className="space-y-4 rounded-lg border p-4">
          <p className="break-words">
            <strong>{t("notifications.recipient")}: </strong>
            {preview.recipient || t("notifications.no_email")}
          </p>
          <h2 className="text-lg font-medium">{preview.subject}</h2>
          <p className="break-words whitespace-pre-line">{preview.body}</p>
          {preview.action_url && (
            <a className="block break-all underline" href={preview.action_url}>
              {preview.action_url}
            </a>
          )}
        </section>
        <FormContent>
          {!preview.eligible && (
            <p role="alert">{t("notifications.verified_email_required")}</p>
          )}
          <Form action={path} method="post">
            {({ processing }) => (
              <>
                <input
                  type="hidden"
                  name="preview_token"
                  value={preview.token}
                />
                <Button
                  type="submit"
                  disabled={processing || !preview.eligible}
                >
                  {t("notifications.confirm")}
                </Button>
              </>
            )}
          </Form>
          <Link className="underline" href={path}>
            {t("notifications.history")}
          </Link>
        </FormContent>
      </PageCanvas>
    </JobWorkspace>
  );
}

function NotificationHeading({ children }: { children: React.ReactNode }) {
  const Tag = usePage().props.job_context ? "h2" : "h1";
  return <Tag className="text-page font-display">{children}</Tag>;
}
